<template>
  <div class="copiar-aulas">
    <div class="mt-2">
      <v-btn text icon :to="{ name: 'diario-escolar-aulas', params: { ano, cdturma, disciplina, tipoDeEnsino, cdinstruc, AEEouACP, pagina } }">
        <v-icon>arrow_back</v-icon>
      </v-btn>
    </div>

    <v-alert type="error" :value="errorText !== '' || msgArrayError.length > 0" dark class="mb-3">
      <div v-if="errorText !== ''">{{ errorText }}</div>
      <div v-if="msgArrayError.length > 0">
        <div><strong>{{ nomeMsgError }}</strong></div>
        <ul v-for="error of msgArrayError" :key="error.key" style="margin-left: 10px;">
          <li>{{ error }}</li>
        </ul>
      </div>
    </v-alert>

    <v-stepper v-model="step" :disabled="requestingData" class="mt-2">
      <v-stepper-header>
        <v-stepper-step :complete="step > 1" step="1">Selecionar Aulas</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step :complete="step > 2" step="2">Escolher Turma</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step :complete="step > 3" step="3">Escolher Datas</v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <table class="table-siged mb-3">
            <thead>
              <tr>
              <th></th>
                <!-- <th style="text-align:center"><CheckBoxCustom :disabled="requestingData" true-value="S" false-value="N" v-model="selecionarTodasAulas" @input="marcarTodasAulas()"/></th> -->
                <th>Data</th>
                <th>Código Aula</th>
                <th>Assunto Lecionado</th>
                <th>Período Avaliativo</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="aulasCadastradas.length === 0">
                <td colspan="5">Nenhuma aula encontrada!</td>
              </tr>
              <tr v-for="key in aulasCadastradas" :key="key.id">
                <td style="text-align:center"><CheckBox :disabled="requestingData" v-model="aulasSelecionadas" :val="key.identificadoraula" @input="checkAula()"/></td>
                <td>{{ key.dataaula }}</td>
                <td>{{ key.identificadoraula }}</td>
                <td>{{ key.descricaoassuntolecionado }}</td>
                <td>{{ key.dspravadi }}</td>
              </tr>
            </tbody>
          </table>
          <div class="d-flex flex-wrap justify-space-around justify-md-space-between align-center">
            <v-pagination
              :disabled="requestingData"
              v-model="paginaAtual"
              :length="quantidadePaginas"
              total-visible="7"
            />
            <v-btn class="rounded-sm font-weight-regular" color="teal" :disabled="aulasCadastradas.length === 0 || requestingData" :dark="!requestingData" @click="selecionarAula">Próximo</v-btn>
          </div>
        </v-stepper-content>

        <v-stepper-content step="2">
          <form @submit.prevent="selecionarTurma">
            <Validator label="" v-for="{ turma } in turmas" :key="turma.id">
              <CheckBox name="turma" v-model="form.turmas" :label="turma.nmturma" :val="turma.cdturma"/>
            </Validator>
            <div class="alinhar-botoes">
              <v-btn class="rounded-sm font-weight-regular" type="submit" color="teal" :loading="loading" dark>Próximo</v-btn>
              <v-btn class="rounded-sm font-weight-regular" text @click="step = 1">Voltar</v-btn>
            </div>
          </form>
        </v-stepper-content>

        <v-stepper-content step="3">
          <div class="copiar-aulas-turma">
            <div><strong>Turma(s): </strong>{{ exibirTurmasSelecionadas() }}</div>
          </div>
          <form @submit.prevent="onSubmit">
            <div class="bloco-aula" v-for="(key, index) in form.aulas" :key="key.id">
              <div class="bloco-aula-dados">
                <div><strong>Código Aula: {{ key.identificadoraula }}</strong></div>
                <div><strong>Período Avaliativo: {{ key.dspravadi }}</strong></div>
                <div style="flex: 0 0 100%;"><strong>Assunto Lecionado: {{ key.descricaoassuntolecionado }}</strong></div>
                <div><strong>Desenvolvimento da Aula: {{ key.descricaodesenvolvimentoaula }}</strong></div>
                <div><strong>Recursos Utilizados: {{ key.descricaorecursosutilizados }}</strong></div>
                <div><strong>Atividades Associada: {{ key.descricaoatividadeassociada }}</strong></div>
              </div>
              <InputDate label="Data Aula" v-model="form.aulas[index].dataaula" :v="$v.form.aulas.$each[index].dataaula"/>
              <Input type="text" label="Assunto Lecionado" v-model="form.aulas[index].descricaoassuntolecionado" :v="$v.form.aulas.$each[index].descricaoassuntolecionado"/>
            </div>

            <div class="alinhar-botoes">
              <v-btn class="rounded-sm font-weight-regular" type="submit" color="teal" :loading="loading" dark>Salvar</v-btn>
              <v-btn class="rounded-sm font-weight-regular" text @click="step = 2">Voltar</v-btn>
            </div>
          </form>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
    <v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0"  >
        <div class="d-flex justify-space-between align-center">
           <span> {{ submitText }}</span>
            <v-btn class="text-right" variant="text"  icon  @click="snackbar = false" > <v-icon>close</v-icon> </v-btn>
        </div>
    </v-snackbar>
  </div>
</template>

<script>
import store from '@/store/index';
import { required, maxLength } from 'vuelidate/lib/validators';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import moment from 'moment';

const DiarioEscolarRepository = RepositoryFactory.get('diarioEscolar');

const dadosUser = () => ({
  ...store.getters.userProfessor,
  ...store.getters.school,
});

export default {
  name: '',
  props: {
    ano: [String, Number],
    cdturma: [String, Number],
    disciplina: [String, Number],
    tipoDeEnsino: [String],
    cdinstruc: [Number],
    pagina: [Number],
    AEEouACP: [Boolean],
  },
  data() {
    return {
      step: 0,
      aulasCadastradas: [],
      aulasSelecionadas: [],
      selecionarTodasAulas: 'N',
      turmas: [],
      errorText: '',
      msgArrayError: [],
      nomeMsgError: '',
      snackbar: false,
      submitText: '',
      loading: false,
      //tipoDeEnsino: to.params.tipoDeEnsino,
      form: {
        aulas: [],
        turmas: [],
      },
      paginaAtual: 1,
      quantidadePaginas: 0,
      params: '',
      requestingData: false,
      aulas: {},
    };
  },
  async beforeRouteEnter(to, from, next) {
    if(typeof to.params.ano === 'undefined' || typeof to.params.cdturma === 'undefined' || typeof to.params.disciplina === 'undefined'){
      return next('/diario-escolar');
    }
    return next(vm => {vm.params = to.params});
  },
  validations: {
    form: {
      aulas: {
        required,
        $each: {
          dataaula: { required, isValidDate: (value) => moment(value, 'DD/MM/YYYY').isValid() },
          descricaoassuntolecionado: { required, maxLength: maxLength(400) },
        }
      }
    },
  },
  async mounted() {
    this.carregarDados();
  },
  watch: {
    paginaAtual(valorNew) {
      this.params.paginaAtual = valorNew;
      this.carregarDados();
    },
  },
  methods: {
    async carregarDados() {
      this.$Progress.start();
      this.requestingData = true;
      const { data } = await DiarioEscolarRepository.getAulasProfessor({
      ...dadosUser(),
      aaletivo: this.params.ano,
      cdturma: this.params.cdturma,
      cddiscipl: this.params.disciplina,
      page: this.params.paginaAtual,
      ...this.params.filtroBusca,
      orderdata: this.params.orderData,
      orderperiodo: this.params.orderPeriodo,
      tipoDeEnsino: this.params.tipoDeEnsino,
      cdinstruc: this.params.cdinstruc,
      AEEouACP: this.params.AEEouACP,
    });

    const response = await DiarioEscolarRepository.getTurmasPorDisciplinaProfessor({
      ...dadosUser(),
      aaletivo: this.params.ano,
      cddiscipl: this.params.disciplina,
      cdturma: this.params.cdturma,
      tipoDeEnsino: this.params.tipoDeEnsino,
      cdinstruc: this.params.cdinstruc,
    });

    this.load(data, response.data.results);
    },
    load(data, turmas) {
      this.turmas = turmas;
      this.form.turmas.push(this.cdturma);
      this.aulasCadastradas = [ ...data.results.aulas.data.map( aulas =>
                                                                         {
                                                                          return {
                                                                            ...aulas,
                                                                            dataaula: moment(aulas.dataaula, 'YYYY-MM-DD').format('DD/MM/YYYY')

                                                                          }
                                                                      }
                                                              )
                              ];
      this.aulasCadastradas.forEach(aula => {
        this.aulas[aula.identificadoraula] = aula;
      });
      this.step = 1;
      this.quantidadePaginas = data.results.aulas.last_page;
      this.requestingData = false;
      this.$Progress.finish();
    },
    marcarTodasAulas() {
       (this.selecionarTodasAulas === 'S') ? this.aulasSelecionadas = this.aulasCadastradas.map( (elem) => {
         return elem['identificadoraula'];
       }) : this.aulasSelecionadas= [];
    },
    checkAula() {
      (this.aulasCadastradas.length !== this.aulasSelecionadas.length) ? this.selecionarTodasAulas = 'N' :
      this.selecionarTodasAulas = 'S';
    },
    selecionarAula() {
      this.errorText = '';
      this.msgArrayError = [];
      if(this.aulasSelecionadas.length === 0){
        this.nomeMsgError = '';
        this.errorText = 'Selecione ao menos uma aula.';
        if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
        return;
      }
      this.form.aulas = Object.values(this.aulas).filter(key => this.aulasSelecionadas.indexOf(key.identificadoraula) >= 0);
      this.step = 2;
    },
    selecionarTurma() {
      this.msgArrayError = [];
      if(this.form.turmas.length === 0) {
        this.nomeMsgError = '';
        this.errorText = 'Selecione ao menos uma turma.';
        return;
      }
      this.step = 3;
    },
    async onSubmit(){
      this.errorText = '';
      this.nomeMsgError = '';
      this.msgArrayError = [];
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.errorText = 'Preencha todos os campos corretamente.';
        if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
        return;
      }

      try {
        this.loading = true;
        const aulas = this.form.aulas.map( aula => {
          return {
            ...aula,
            dataaula: moment(aula.dataaula, 'DD/MM/YYYY').format('YYYY-MM-DD')
          }
        })

        const { data } = await DiarioEscolarRepository.postReplicarAulas({...this.form, aulas: aulas, cdinstruc: this.cdinstruc, aaletivo: this.ano});


        this.submitText = data.message;
        this.snackbar = true;
        this.$root.$router.push({
          name: 'diario-escolar-aulas',
          params: {
            ano: this.ano,
            cdturma: this.cdturma,
            disciplina: this.disciplina,
            tipoDeEnsino: this.tipoDeEnsino,
            cdinstruc: this.cdinstruc,
            pagina: this.pagina,
            AEEouACP: this.AEEouACP,

          },
        });

        this.step = 4;
      }
      catch(error) {
        if (error.response.data.status == 'ERROR_BUSINESS_RULE') {
          this.msgArrayError = error.response.data.errorMessage;
          const { turma } = this.turmas.find(t => t.cdturma.replace(' ', '') === error.response.data.cdturma);
          if (typeof turma !== 'undefined') { this.nomeMsgError = `Turma: ${turma.nmturma}`; }
          if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
        }
      }
      this.loading = false;
    },
    exibirTurmasSelecionadas() {
      const texto = this.turmas.filter(key => this.form.turmas.indexOf(key.cdturma) >= 0).reduce((total, { turma }) => total + `${turma.nmturma}, `, '');
      return texto.substring(0, texto.length-2);
    },
  }
}
</script>

<style lang="scss">
.copiar-aulas{
  .alinhar-botoes{
    text-align: right;
  }

  .bloco-aula{
    padding: 11px 10px;
    font-size: 16px;
    border: 1px solid #009688;
    box-shadow: 0 0 1px -1px #009688;
    border-left: 5px solid #009688;
    margin: 2px 2px 15px 0px;

    .bloco-aula-dados{
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 11px;

      div{
        flex: 0 0 50%;
      }
    }
  }

  .copiar-aulas-turma{
    font-size: 16px;
    margin-bottom: 10px;
  }
}
</style>
